import client from './AxiosClient'

const enquiryService = {
    getAll : (params) => client.get("/enquiry", { params }),
    updateStatus : (data) => client.put(`/enquiry/update-status`,data),

}

export default enquiryService;